'use strict';

var React = require('react');
var array = require('../../../helpers/array.js');
var functions = require('../../../helpers/functions.js');
var component$2 = require('../../Chip/component.js');
var component = require('../../forms/Input/component.js');
var component$1 = require('../../Icon/component.js');
require('../../Tooltip/component.js');
var pill = require('../../Pill/pill.js');
require('../../Pill/pillButton.styles.js');
var filterPopin_styles = require('./filterPopin.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FilterCheckboxPopin = ({ id, node = { current: null }, queryParam, colKey, title, checkboxes, isPopinRightSide = false, $top, $left, addToQueryParams = functions.noop, removeFromQueryParams = functions.noop, searchPlaceholder = 'Rechercher', disableSearch = false, searchDisabled = false, labelCheckAll = 'Tous', pillFirst = false, }) => {
    const [searchValue, setSearchValue] = React.useState(queryParam?.key === colKey && queryParam?.search ? queryParam.search : '');
    const [filterValue, setFilterValue] = React.useState(queryParam?.key === colKey && queryParam?.value && Array.isArray(queryParam?.value)
        ? queryParam.value
        : []);
    const onSortBy = (param) => {
        removeFromQueryParams({ key: colKey });
        if (param.search !== '' || param.value.length > 0) {
            addToQueryParams({ ...param, key: colKey });
        }
    };
    const onInputChange = (e) => {
        const val = e.target.value === undefined || e.target.value === null ? '' : e.target.value;
        setSearchValue(val);
        if (val === '' || val.length > 2) {
            onSortBy({ search: val, value: filterValue });
        }
    };
    const onCheckChange = (filterVal) => (e) => {
        const newCheckboxes = array.addOrRemove(filterValue, filterVal);
        setFilterValue(newCheckboxes);
        onSortBy({ search: searchValue, value: newCheckboxes });
    };
    const onCheckChangeAll = (e) => {
        let newCheckboxes;
        if (filterValue.length === checkboxes.length) {
            newCheckboxes = [];
        }
        else {
            newCheckboxes = checkboxes.map(c => c.value);
        }
        setFilterValue(newCheckboxes);
        onSortBy({ search: searchValue, value: newCheckboxes });
    };
    const _searchDisabled = searchDisabled || disableSearch;
    return (React__default.default.createElement(filterPopin_styles.ContainerStyled, { id: id, ref: node, isPopinRightSide: isPopinRightSide, "$top": $top, "$left": $left },
        !_searchDisabled && (React__default.default.createElement(component.Input, { autoFocus: true, id: `${id}-search`, placeholder: searchPlaceholder, value: searchValue, onChange: onInputChange, prefix: React__default.default.createElement(component$1.Icon, { name: "search-filled", size: "m" }) })),
        React__default.default.createElement(filterPopin_styles.FilterDiv, { iFirstElement: _searchDisabled }, title),
        React__default.default.createElement(filterPopin_styles.FlexDivAll, null,
            React__default.default.createElement(filterPopin_styles.Checkbox, { name: "all", id: `${id}-check-all`, checked: checkboxes.map(c => c.value).every(c => filterValue.includes(c)), onChange: onCheckChangeAll }),
            React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-check-all` }, labelCheckAll)),
        checkboxes.map(checkbox => (React__default.default.createElement(filterPopin_styles.FlexDivCheckbox, { key: checkbox.value },
            React__default.default.createElement(filterPopin_styles.Checkbox, { value: checkbox.value, id: `${id}-check-${checkbox.value}`, checked: filterValue.includes(checkbox.value), onChange: onCheckChange(checkbox.value) }),
            checkbox.chipVariant ? (React__default.default.createElement(component$2.Chip, { label: checkbox.label, variant: checkbox.chipVariant, textAlign: "start" })) : (React__default.default.createElement(filterPopin_styles.CheckboxPillLabelContainerStyled, null,
                checkbox.pillColor && pillFirst && React__default.default.createElement(pill.Pill, { color: checkbox.pillColor, withTooltip: false }),
                React__default.default.createElement(filterPopin_styles.LabelStyled, { htmlFor: `${id}-check-${checkbox.value}` }, checkbox.label),
                checkbox.pillColor && !pillFirst && React__default.default.createElement(pill.Pill, { color: checkbox.pillColor, withTooltip: false }))))))));
};

exports.FilterCheckboxPopin = FilterCheckboxPopin;
//# sourceMappingURL=filterCheckboxPopin.js.map
